// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import style from './Comments.scss';

export type Comment = {
  name: string;
  text: string;
  purchases: number;
  image: ?string;
};

type Props = {
  +comments: Comment[];
};

export default class Comments extends PureComponent<Props> {

  render() {
    return (
      <div className={style.commentsWrap}>
        <FormattedMessage id="newOrder.quote.comments.title">{
          text => <h3>{text}:</h3>
        }</FormattedMessage>
        <section className={style.comments}>
          {this.props.comments.map((c: Comment, index: number) => (
            <article key={index} className={style.comment}>
              <section className={style.header}>
                <section className={style.user}>
                  <img src={c.image} alt="Qempo"/>
                  <p className={style.name}>{c.name}</p>
                </section>
                <FormattedMessage id="newOrder.quote.comments.header.purchases">{
                  text => <p className={style.purchases}>{`${text}: ${c.purchases}`}</p>
                }</FormattedMessage>
              </section>
              <p className={style.text}>{c.text}</p>
            </article>
          ))}
        </section>
      </div>);
  }
}

Comments.propTypes = {
  comments: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/components/Comments/Comments.jsx